import React, { useState } from "react";
import "./Banner.css";
import { Controller, useForm } from "react-hook-form";
import Common_Form from "../../common_components/common_form/Common_Form";

function Banner() {
  // const [showModal, setShowModal] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  return (
    <section className="banner_section position-relative">
      <div className="bg_img">
        <img
          src="/assets/images/home/banner/dpu_diwali_banner2.png"
          alt="Online MBA - Dr. D. Y. Patil"
          className="banner_img"
        />

        <div className="mobile_view">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 banner_text_col">
                <div className="dsu_addmission">
                  <div className="bannerContent">
                    <h1 className="banner_start">
                      Scale Your Career <br /> with&nbsp;Dr. D. Y. Patil
                    </h1>
                    <h2 className="dyText">Online MBA</h2>
                    <div className="admi__content-btn">
                      <div className="bg_whi">
                        <span className="dy_description">
                          Powered with Gen AI Tools
                        </span>
                      </div>
                      <div className="features_strip">
                        <div className="feature_box">
                          <div className="icon">
                            <img
                              src="/assets/images/home/banner/white.svg"
                              alt=""
                            />
                          </div>
                          <div>
                            <strong>100% Palcement</strong>
                            <br />
                            <span>Assistance</span>
                          </div>
                        </div>
                        <div className="feature_box">
                          <div className="icon">
                            <img
                              src="/assets/images/home/banner/white.svg"
                              alt=""
                            />
                          </div>
                          <div>
                            <strong>Zero Cost</strong>
                            <br />
                            <span>EMI Option</span>
                          </div>
                        </div>
                        <div className="feature_box">
                          <div className="icon">
                            <img
                              src="/assets/images/home/banner/white.svg"
                              alt=""
                            />
                          </div>
                          <div>
                            <span>Get Scholarship</span>
                            <br />
                            <strong>upto *Rs 10000/-</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4 className="trans_text">Admissions Open Jan-2027</h4>
                  </div>
                </div>
              </div>

              <div className="dsu_intro col-lg-5 col-md-12 col-sm-12 formsec">
                <div id="applyBox">
                  <div className="applyBox">
                    <div className="dsu_form bggradient-yellow p-0">
                      <div className="contact_fild p-0">
                        <div
                          className="npf_form"
                          data-height="400px"
                          data-w="9969a6eadada28951bbdd9c68969ce4f"
                        >
                          <Common_Form />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="desktop_view">
          <Common_Form />
        </div>
      </div>
      <div class="highlight__section position-relative">
        <div class="eligblity position-relative">
          <p>
            <span>Eligibility </span> Graduate in any discipline, from a
            recognized University. Min 50% for regular and 45% for category
            students
          </p>
        </div>
      </div>
    </section>
  );
}

export default Banner;

//  <section className="Banner">
//     <div className="container-fluid p-0">

//        <div className="banner_holder">
//         <img src="/assets/images/home/banner/banner.png" className="banner_img" />

//         <div className="btn_holder">
//           <Red_Btn btn_name="DOWNLOAD BROCHURE" onClick={() => { setShowModal(true) }} />
//         </div>

//       </div>
//     </div>

//     <Enquiry_Form_Modal
//       show={showModal}
//       onHide={() => { setShowModal(false) }}
//     />

//   </section>
